import CollectedCommissionReport from './CollectedCommissionReport';
import GoLiveConversionReport from './GoLiveConversionReport';
import MrrReport from './MrrReport';
import SalesReport from './SalesReport';

export default {
  CollectedCommissionReport,
  GoLiveConversionReport,
  MrrReport,
  SalesReport,
};
